import { render } from "./mped-amortization-plan-work-group-view.vue?vue&type=template&id=5f156056"
import script from "./mped-amortization-plan-work-group-view.vue?vue&type=script&setup=true&lang=js"
export * from "./mped-amortization-plan-work-group-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mped/views/amortization/main-asset/mped-amortization-plan-work-group-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f156056"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f156056', __exports__)) {
    api.reload('5f156056', __exports__)
  }
  
  module.hot.accept("./mped-amortization-plan-work-group-view.vue?vue&type=template&id=5f156056", () => {
    api.rerender('5f156056', render)
  })

}


export default __exports__